import { Modal } from "components";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { useRole } from "hooks/data/use-roles";
import { applicationFeatures } from "_graphql/data/features";
import { useMemo } from "react";

export default function ViewRoleContainer({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const { role, loading: loadingRole } = useRole(
        (searchParams?.id as string) || ""
    );

    const privileges = useMemo(() => {
        try {
            const base64 = role?.privileges;
            if (!base64) return [];
            return JSON.parse(atob(base64)) || [];
        } catch {
            return [];
        }
    }, [role?.privileges]);

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={loadingRole}
            title="View User Role"
            description="Details of the user role">
            <div className="space-y-6 divide-y divide-gray-200">
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Position
                    </label>
                    <div className="block text-sm font-medium text-primary">
                        {role?.position}
                    </div>
                </div>
                <div className="space-y-6 pt-5">
                    <div className="flex items-center justify-between">
                        <div className="block text-sm font-medium text-primary">
                            Privileges
                        </div>
                    </div>
                    <div className="grid gap-4 md:grid-cols-2">
                        {privileges?.map((privilege: string) => (
                            <div
                                key={privilege}
                                className="flex items-start space-x-3 p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors">
                                <div className="flex-1 space-y-1">
                                    <div className="flex items-center gap-2">
                                        <div className=" cursor-pointer text-muted">
                                            {privilege}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    );
}
